export const PASSWORD_REQUIREMENTS_HINT =
  "At least 8 characters, including at least one letter and one number.";

export const PASSWORD_VALIDATION_ERROR =
  "Password must be at least 8 characters and include at least one letter and one number.";

export function isPasswordValid(password: string): boolean {
  if (password.length < 8) {
    return false;
  }
  if (!/[a-zA-Z]/.test(password)) {
    return false;
  }
  if (!/[0-9]/.test(password)) {
    return false;
  }
  return true;
}
